import * as yup from 'yup';

import { PHONE_REGEXP, STRONG_EMAIL_REGEXP } from '@/utils/constants';

export enum LocationFormSteps {
  Application = 'application',
  Calendly = 'calendly',
  Success = 'success',
}

export enum TourType {
  IN_PERSON = 'in-person',
  VIRTUAL = 'virtual',
}

// values tied to translation keys
export enum LocationFormActions {
  General = 'general',
  GetNotified = 'get-notified',
  ScheduleCall = 'schedule-call',
  GetStarted = 'get-started',
}

export type CalendlyLinkByTour = {
  type: TourType;
  calendlyLink: string;
};

export const applicationFormSchema = yup
  .object({
    firstName: yup.string().trim().required('firstname-required'),
    lastName: yup.string().trim().required('lastname-required'),
    email: yup
      .string()
      .trim()
      .required('email-required')
      .email('email-invalid')
      .matches(STRONG_EMAIL_REGEXP, 'email-invalid'),
    phone: yup
      .string()
      .trim()
      .required('telephone-required')
      .matches(PHONE_REGEXP, 'telephone-invalid'),
    company: yup.string().trim().required('company-required'),
    teamSize: yup.string().required('teamSize-required'),
    referenceCode: yup.string(),
    comments: yup.string(),
    location: yup.string(),
    industry: yup.string().required('industry-required'),
    textMessageOptIn: yup.boolean(),
  })
  .required();

export type ApplicationFormData = yup.InferType<typeof applicationFormSchema>;
